import React, {Component} from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import Slide from '@material-ui/core/Slide';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';

// Actions only used here...
import {Spotify} from '../../../actions/index';

import config from '../../../config';

import * as audioMapping from '../../../tools/maps/audio';
import * as timeConversion from '../../../tools/conversion/time';

import Dropzone from 'react-dropzone'

import { translate } from 'react-i18next';

import theme from '../../../themes.js';
import './styles/trackeditor.css';

const styles = theme => ({
  appBar: {
    color: '#fff',
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  chip: {
    margin: theme.spacing.unit / 2,
  }
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class TrackEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      track: null,

      newArtist: ''
    }
    this.handleSave=this.handleSave.bind(this);
    this.handleClose=this.handleClose.bind(this);
    this.addArtist=this.addArtist.bind(this);
    this.handleMetaChange = this.handleMetaChange.bind(this);
    this.spotifyAutoFill = this.spotifyAutoFill.bind(this);
    this.onFileDrop=this.onFileDrop.bind(this);
    this.dispatch = props.dispatch;
  }

  componentWillMount() {
    const { t } = this.props;
    this.texts = t('component.module.artist.trackEditor', {returnObjects: true});
  }

  componentDidUpdate() {
    this.handleIncomingTrack(this.props.track);
  }

  handleIncomingTrack(track) {
    if (this.state.track || !track) return;

    if (Object.keys(track).length === 0 && track.constructor === Object) {
      this.setState({
        track: {
          // Model props
          _id: '',
          title: '',
          artists: [{name: 'Jørgen Hanssen'}],
          stores: {
            spotify: '',
            itunes: '',
            youtube: '',
          },
          metadata: {
            key: null,
            bpm: null,
            length: null,
            loudness: null,
            genre: null,
          },
          releaseDate: null,
          explicit: false,

          // Extra check props, not in model
          _update: false,
          _image: null,
          _removeImage: false,
        },
      })
    } else {
      this.setState({
        track: {
          // Model props
          ...track,

          // Extra check props, not in model
          _update: true,
          _image: null,
          _removeImage: false,
        }
      });
    }
  }

  handleClose() {
    if (this.state.track._image)
      window.URL.revokeObjectURL(this.state.track._image.preview);

    this.props.onClose();
    this.setState({track: null});
  }
  handleSave() {
    this.validateTrack()
    .then(track => {
      this.props.onSave(track, this.state._update);
      this.handleClose();
    })
    .catch(err => {
      console.error(err);
    })
  }

  validateTrack() {
    return new Promise((resolve, reject) => {
      let track = this.state.track;

      if (track.title.trim() === '')
        reject('You should probably add a title...');
      if (track.artists.length === 0)
        reject('Some artist probably made this? Add one...');

      let artistNames = track.artists.map(artist => artist.name);
      artistNames.some((name, i) => {
        if (!name || name.trim() === '')
          reject(`The ${i+1}th artist has a weird name? Change it...`);

        if (artistNames.indexOf(name) !== i)
          reject(`${name} should only appear once...`);

        return true;
      });


      resolve(track);
    })
  }




  addArtist(event) {
    event.preventDefault();
    let artist = event.target[0].value;
    this.setState({
      track: {...this.state.track, artists: [...this.state.track.artists, {name: artist}]},
      newArtist: ''
    })
  };
  deleteArtist(key) {
    const artists = [...this.state.track.artists];
    artists.splice(key, 1);
    this.setState({
      track: {...this.state.track, artists},
    })
  };

  handleMetaChange(event) {
    let {track} = this.state;
    let {target} = event;
    this.setState({
      track: {...track, metadata: {...track.metadata, [target.id]: target.value}}
    })
  }


  spotifyAutoFill() {
    let link = this.state.track.stores.spotify;
    if (!link) return console.error("No Spotify link present...");

    Spotify.actions.getSpotifyData(
      link.split('/').pop().split('?')[0]
    )
    .then(data => {
      let {track} = this.state;
      this.setState({
        track: {
          ...track,
          artists: data.artists,
          title: data.title,
          releaseDate: data.releaseDate,
          explicit: data.explicit,
          isrc: data.isrc,
          metadata: {
            ...track.metadata,
            key: `${audioMapping.keys[data.metadata.key]} ${audioMapping.modality[data.metadata.mode]}`,
            bpm: Math.round(data.metadata.tempo),
            length: timeConversion.secondsToTimestamp(data.metadata.duration_ms/1000),
            loudness: data.metadata.loudness.toFixed(2)+' db'
          }
        }
      })
    })
    .catch(err => console.error(err));

  }




  onFileDrop(acceptedFiles, rejectedFiles) {
    if ((acceptedFiles.length === 0)) return;

    let _image = acceptedFiles[0];

    this.setState({track: {...this.state.track, _image, _removeImage: false}});
  }


  render() {
    if (!this.state.track) return null;
    const { classes } = this.props;

    const {track} = this.state;

    let artistChips = track.artists.map((data, key) => {
      return (
        <Chip
          key={key}
          label={data.name}
          onDelete={() => this.deleteArtist(key)}
          className={classes.chip}
        />
      );
    });

    return (
      <div>
        <Dialog
          fullScreen
          open={Boolean(this.props.track)}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={this.handleClose} aria-label="Close">
                <Icon> clear </Icon>
              </IconButton>
              <div className='module-artist-trackeditor-topbar-title-container'>
                <Typography variant="title" color="inherit">
                  {this.texts.topbar.title}
                </Typography>
                <p className='module-artist-trackeditor-topbar-pretitle'>
                  {this.state.track.title}
                </p>
              </div>
              <Button disabled={!track.stores.spotify} color='inherit' onClick={this.spotifyAutoFill}>
                {this.texts.items.metadata.spotify.find}
              </Button>
              <Button color='inherit' onClick={this.handleSave}>
                {this.texts.saveButton.title}
              </Button>
            </Toolbar>
          </AppBar>


          <div className="module-artist-trackeditor-content-container">
            <div className="module-artist-trackeditor-content-subcontainer">


              <h5> {this.texts.items.title} </h5>
              <Paper className="module-artist-trackeditor-content-itemcontainer">
                <input type="text" value={track.title} onChange={event => this.setState({
                  track: {...track, title: event.target.value}
                })} />
              </Paper>




              <h5> {this.texts.items.artists} </h5>
              <Paper className="module-artist-trackeditor-content-itemcontainer">
                <div className="chip-container">
                  {artistChips}

                  <form onSubmit={this.addArtist}>
                    <input
                      type="text"
                      placeholder="Add artist..."
                      value={this.state.newArtist}
                      onSubmit={this.addArtist}
                      onChange={event => this.setState({
                        newArtist: event.target.value
                      })}
                    />
                  </form>
                </div>
              </Paper>


              <h5> {this.texts.items.releaseDate.title} </h5>
              <div className="module-artist-trackeditor-content-releaseDate-container">
                <TextField
                    defaultValue={track.releaseDate}
                    className={classes.textField}
                    type='date'
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={e => {
                      let releaseDate = (e.target.value === '') ? null : e.target.value;
                      this.setState({
                      track: {...track, releaseDate}
                    })}}
                  />
                  {track.releaseDate ? (
                    <div className='hint'>
                      <Icon style={{color: 'green'}}> info </Icon>
                      <h5 style={{color: 'green'}}>
                        {this.texts.items.releaseDate.isReleased}
                      </h5>
                    </div>
                  ) : (
                    <div className="hint">
                      <Icon style={{color: 'red'}}> info </Icon>
                      <h5 style={{color: 'red'}}>
                        {this.texts.items.releaseDate.notReleased}
                      </h5>
                    </div>
                  )}
              </div>



              <h5> {this.texts.items.platforms} </h5>
              <Paper className="module-artist-trackeditor-content-itemcontainer">
                <div className="stores-container">
                  <div>
                    <img alt='' src='brandLogos/spotify_logo.png' />
                    <img alt='' src='brandLogos/itunes_logo.png' />
                    <img alt='' src='brandLogos/youtube_logo.png' />
                  </div>
                  <div>
                    <p> Spotify </p>
                    <p> Itunes </p>
                    <p> Youtube </p>
                  </div>
                  <div style={{flex: 1}}>
                    <input
                      type="text"
                      placeholder="Add link..."
                      value={track.stores.spotify}
                      onChange={event => this.setState({
                        track: {...track, stores: {...track.stores, spotify: event.target.value}},
                      })}
                    />
                    <input
                      type="text"
                      placeholder="Add link..."
                      value={track.stores.itunes}
                      onChange={event => this.setState({
                        track: {...track, stores: {...track.stores, itunes: event.target.value}},
                      })}
                    />
                    <input
                      type="text"
                      placeholder="Add link..."
                      value={track.stores.youtube}
                      onChange={event => this.setState({
                        track: {...track, stores: {...track.stores, youtube: event.target.value}},
                      })}
                    />
                  </div>
                </div>
              </Paper>


              <h5> {this.texts.items.metadata.title} </h5>
              <Paper className="module-artist-trackeditor-content-itemcontainer">
                <div className="metadata-container">
                  <div style={track.metadata.key ? {color: theme.palette.primary.main} : null}>
                    <Tooltip title={this.texts.items.metadata.key} placement='top'>
                      <Icon> music_note </Icon>
                    </Tooltip>
                    <input
                      id='key'
                      type="text"
                      value={track.metadata.key||''}
                      placeholder={this.texts.items.metadata.key}
                      onChange={this.handleMetaChange}
                    />
                  </div>
                  <div style={track.metadata.bpm ? {color: theme.palette.primary.main} : null}>
                    <Tooltip title={this.texts.items.metadata.bpm} placement='top'>
                      <Icon> favorite </Icon>
                    </Tooltip>
                    <input
                      id='bpm'
                      type="text"
                      value={track.metadata.bpm||''}
                      placeholder={this.texts.items.metadata.bpm}
                      onChange={this.handleMetaChange}
                    />
                  </div>
                  <div style={track.metadata.length ? {color: theme.palette.primary.main} : null}>
                    <Tooltip title={this.texts.items.metadata.length} placement='top'>
                      <Icon> watch_later </Icon>
                    </Tooltip>
                    <input
                      id='length'
                      type="text"
                      value={track.metadata.length||''}
                      placeholder={this.texts.items.metadata.length}
                      onChange={this.handleMetaChange}
                    />
                  </div>
                  <div style={track.metadata.loudness ? {color: theme.palette.primary.main} : null}>
                    <Tooltip title={this.texts.items.metadata.loudness} placement='top'>
                      <Icon> volume_up </Icon>
                    </Tooltip>
                    <input
                      id='loudness'
                      type="text"
                      value={track.metadata.loudness||''}
                      placeholder={this.texts.items.metadata.loudness}
                      onChange={this.handleMetaChange}
                    />
                  </div>
                  <div style={track.metadata.genre ? {color: theme.palette.primary.main} : null}>
                    <Tooltip title={this.texts.items.metadata.genre} placement='top'>
                      <Icon> category </Icon>
                    </Tooltip>
                    <input
                      id='genre'
                      type="text"
                      value={track.metadata.genre||''}
                      placeholder={this.texts.items.metadata.genre}
                      onChange={this.handleMetaChange}
                    />
                  </div>
                </div>
              </Paper>



              <h5> {this.texts.items.coverart.title} </h5>
              <Paper className="module-artist-trackeditor-content-itemcontainer">
                <div className="coverart-container">

                  <Dropzone
                    className="coverart-drop"
                    accept="image/jpeg"
                    disabled={Boolean(track._image) || track._hasImage}
                    multiple={false}
                    onDrop={this.onFileDrop}
                    acceptStyle={{color: 'green'}}
                    rejectStyle={{color: 'red'}}
                  >
                    {
                      track._image || track._hasImage ? (
                        <div className="dropnupload-uploadedimage-container">
                          <div className="content">
                            <img
                              alt=''
                              src={
                                track._hasImage ?
                                `${config.API_ADDRESS}/file/image/${track._id}?quality=standard`
                                :
                                track._image.preview
                              }
                            />
                            <div className="subcontainer">
                              <Tooltip title={this.texts.items.coverart.delete.tooltip}>
                                <div onClick={() => {
                                  if (track._image)
                                    window.URL.revokeObjectURL(track._image.preview);

                                  this.setState({
                                    track: {
                                      ...track,
                                      _image: null,
                                      _removeImage: true,
                                      _hasImage: false,
                                    }
                                  })
                                }}>
                                  <Icon> delete </Icon>
                                </div>
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="dropnupload-container">
                          <Icon fontSize='inherit' color='inherit'> file_upload </Icon>
                          <p> {this.texts.items.coverart.dragAndDrop} </p>
                        </div>
                      )
                    }
                  </Dropzone>
                </div>
              </Paper>



              <h5> {this.texts.items.misc.title} </h5>
                <div className="module-artist-trackeditor-content-misc-container">
                        <div className='misc-item'>
                          <Tooltip title={this.texts.items.misc.explicit.hint} placement='right'>
                            <div className='content'>
                              <Switch checked={track.explicit} color='primary' onChange={(e, checked) => {
                                  this.setState({track: {...track, explicit: checked}})
                                }}
                              />
                              <div className='title'>
                              <h5> {this.texts.items.misc.explicit.title} </h5>
                              </div>
                            </div>
                          </Tooltip>
                        </div>
                </div>







            </div>
          </div>













        </Dialog>
      </div>
    );
  }
}

TrackEditor.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default translate('translations')(withStyles(styles)(TrackEditor));



// WEBPACK FOOTER //
// ./src/components/modules/artist/TrackEditor.js